import React, { useState } from 'react';
import { Grid, TextField } from '@iho-design-system/Loader';
import SearchSVG from '../../assets/images/icons/search.svg';

const Toolbar = ({ hotelNameSaerchPrps }) => {
  const [hotelNameSearchKey, setHotelNameSearchKey] = useState('');

  const handleSearch = (value) => {
    setHotelNameSearchKey(value);
    hotelNameSaerchPrps(value);
  };

  return (
    <Grid>
      <Grid.Wrapper>
        <Grid.Item size="col-12 lg-4 md-6">
          <TextField
            onChange={handleSearch}
            placeholder="جستجو بر اساس نام هتل"
            icon={SearchSVG}
            value={hotelNameSearchKey}
          />
        </Grid.Item>
      </Grid.Wrapper>
    </Grid>
  );
};

export default Toolbar;
